import * as Yup from 'yup'

const CashPaymentFormSchema = total => Yup.object().shape({
  amount: Yup.number().min(total, 'Insufficient Amount').required(),
})

export default CashPaymentFormSchema
